// extracted by mini-css-extract-plugin
export default {"wrapper":"BlogPostsLoading-wrapper-Quq"};